import { CmsMeta } from '../cmsMeta';
import { useConfig } from '../../../config';
import { useTranslation } from '../../../i18n/i18n';
import { useApi } from '../../../state/api';
import { Res } from '../../../state/api-resources';
import { MetaContainer } from '../../../state/meta';
import { Loop54TopSellingProductsRequestBody } from '../../../types';
import { ButtonLink } from '../../Form/Button';
import { Loader } from '../../Loader/Loader';
import { ProductListing } from '../../ProductListing/ProductListing';
import { generateUUID } from '../../utils';
import './CmsTopSellingProducts.css';

export const CmsTopSellingProducts = ({
	take,
	showMore = false,
	showHeading = false,
}: {
	take?: number;
	showMore?: boolean;
	showHeading?: boolean;
}): JSX.Element => {
	const t = useTranslation();
	const config = useConfig();
	const { searchProfileId, randomizeSearchProfileId } = MetaContainer.useContainer();
	const loop54PostHeaders = {
		'Api-Version': 'V3',
		'User-id': randomizeSearchProfileId ? generateUUID() : searchProfileId,
	};
	const resultsLimit = take ?? 12;
	const offset = 0;
	const topSellingProductsPayload: Loop54TopSellingProductsRequestBody = {
		resultsOptions: {
			skip: offset,
			take: resultsLimit,
			sortBy: [
				{
					type: 'attribute',
					attributeName: 'boost',
					order: 'desc',
				},
			],
		},
	};

	const { data } = useApi(
		Res.topSellingProductsLoop54,
		{ take: resultsLimit },
		config.loop54Api,
		topSellingProductsPayload,
		loop54PostHeaders,
		'POST'
	);

	if (!data) return <Loader />;
	if (!data.results || data.results.count === 0) return <></>;

	return (
		<div className={`top-selling-products ${showMore ? 'show-more' : ''}`}>
			{showHeading && <h2>{t.topSelling.heading}</h2>}
			<ProductListing products={data.results.items} />
			{showMore && (
				<center>
					<ButtonLink linkTo={t.routes.topSellers}>{t.generic.viewMore}</ButtonLink>
				</center>
			)}
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A row the market fills itself, ordered by the `boost` attribute in the pim. Despite the name it does not read sales figures, so a boosted product outranks an actual best seller. Nothing to pick.',
	example: ['CmsTopSellingProducts', { index: 7, take: 12, showMore: true, showHeading: true }],
};
